import AccordionSpecs from 'componentSpecs/accordion.json'
import { useState } from 'react'

import { type IPktAccordion, PktAccordion } from '@/components/accordion/Accordion'
import { PktAccordionItem } from '@/components/accordion/AccordionItem'

export default function Accordion() {
  const [accordionSpecs] = useState(AccordionSpecs.props)

  const accordionItems = [
    {
      id: 'apningstid',
      title: 'Hva er åpningstidene?',
      content: 'Vi åpner om morgenen når vi føler oss klar for det, og stenger når middagen er klar!',
    },
    { id: 'dresscode', title: 'Hva er dresscode?', content: 'Vi sier som i Florida: No shirt? No shoes? No service!' },
    { id: 'lokale', title: 'Kan jeg ta med mat og drikke til lokalet?', content: 'Bare hvis vi får smake!' },
    { id: 'kjæledyr', title: 'Kan jeg ta med kjæledyr?', content: 'Vi tillater kun pelsdyr som mjauer!' },
  ]

  return (
    <main
      className="page-main pkt-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: '1em',
        backgroundColor: 'var(--pkt-color-surface-default-faded-green)',
      }}
    >
      <h1>Accordion </h1>
      <p>A green background is set to be able to see the outlined skin</p>

      <section>
        <h2 id="accordion-heading">Accordion eksempel (kun én accordionItem åpen tillatt), compact</h2>
        <PktAccordion
          aria-labelledby="accordion-heading"
          key="compact"
          compact
          skin={'borderless'}
          name="accordion-items"
        >
          {accordionItems.map((item, index) => {
            return (
              <PktAccordionItem id={item.id} key={item.id} title={item.title} defaultOpen={'apningstid' === item.id}>
                {item.content}
              </PktAccordionItem>
            )
          })}
        </PktAccordion>
      </section>

      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '2rem', columnGap: '2rem' }}>
        <h2 style={{ gridColumn: '1 / 3' }}>PktAccordionItem (standalone, uten wrapping av PktAccordion)</h2>
        <div style={{ gridColumn: '1 / 2', display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
          <h3>Standard</h3>
          <PktAccordionItem id="apningstid" title="Borderless skin (standard)">
            {accordionItems[0].content}
          </PktAccordionItem>
          <PktAccordionItem id="apningstid" title="Outlined skin" skin="outlined">
            {accordionItems[0].content}
          </PktAccordionItem>
          <PktAccordionItem id="apningstid" title="Beige skin" skin="beige">
            {accordionItems[0].content}
          </PktAccordionItem>
          <PktAccordionItem id="apningstid" title="Blue skin" skin="blue">
            {accordionItems[0].content}
          </PktAccordionItem>
        </div>
        <div style={{ gridColumn: '2 / 3', display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
          <h3>Compact</h3>
          <PktAccordionItem id="apningstid" title="Borderless skin (standard)" skin="borderless" compact>
            {accordionItems[0].content}
          </PktAccordionItem>
          <PktAccordionItem id="apningstid" title="Outlined skin" skin="outlined" compact>
            {accordionItems[0].content}
          </PktAccordionItem>
          <PktAccordionItem id="apningstid" title="Beige skin" skin="beige" compact>
            {accordionItems[0].content}
          </PktAccordionItem>
          <PktAccordionItem id="apningstid" title="Blue skin" skin="blue" compact>
            {accordionItems[0].content}
          </PktAccordionItem>
        </div>
      </section>

      <section>
        <h2>PktAccordion i PktAccordion</h2>
        <PktAccordion key="nested" compact={false} skin="borderless">
          <PktAccordionItem id="parent-1" key="parent-1" title="Parent Accordion Item 1">
            <PktAccordion key="nested-1" compact skin="borderless">
              <PktAccordionItem id="child-1" key="child-1" title="Child Accordion Item 1">
                Innhold for Child Accordion Item 1
              </PktAccordionItem>
              <PktAccordionItem id="child-2" key="child-2" title="Child Accordion Item 2">
                Innhold for Child Accordion Item 2
              </PktAccordionItem>
            </PktAccordion>
          </PktAccordionItem>
          <PktAccordionItem id="parent-2" key="parent-2" title="Parent Accordion Item 2">
            Innhold for Parent Accordion Item 2
          </PktAccordionItem>
        </PktAccordion>
      </section>

      {accordionSpecs.skin.type.map((skinType: string, index: number) => (
        <section key={`skin-${index}`} style={{ display: 'flex', flexDirection: 'column', rowGap: '2rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '2rem', columnGap: '2rem' }}>
            <h2>Skin: {skinType} (no state handling)</h2>
            <div style={{ gridColumn: '1 / 2', display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
              <h3 id={`heading-${skinType}-default`}>{`Default ${skinType} `}</h3>
              <PktAccordion key={`skin-${skinType}`} compact={false} skin={skinType as IPktAccordion['skin']}>
                {accordionItems.map((item, index) => (
                  <PktAccordionItem id={item.id} key={skinType + item.id} title={item.title}>
                    {item.content}
                  </PktAccordionItem>
                ))}
              </PktAccordion>
            </div>

            <div style={{ gridColumn: '2 / 3', display: 'flex', flexDirection: 'column', rowGap: '1rem' }}>
              <h3 id={`heading-${skinType}-compact`}>Compact {skinType}</h3>
              <PktAccordion key="compact" compact skin={skinType as IPktAccordion['skin']}>
                {accordionItems.map((item) => (
                  <PktAccordionItem id={'compact' + item.id} key={'compact' + item.id} title={item.title}>
                    {item.content}
                  </PktAccordionItem>
                ))}
              </PktAccordion>
            </div>
          </div>
        </section>
      ))}
      {/* Dark mode */}
      <section style={{ backgroundColor: 'var(--pkt-color-background-default)', padding: '1rem' }} data-mode="dark">
        <h2>Dark mode</h2>
        <PktAccordion key="dark-mode" compact={false} skin="borderless">
          {accordionItems.map((item) => (
            <PktAccordionItem
              id={'darkmode' + item.id}
              key={'darkmode' + item.id}
              title={item.title}
              defaultOpen={item.id === 'apningstid'}
            >
              {item.content}
            </PktAccordionItem>
          ))}
        </PktAccordion>
      </section>
    </main>
  )
}
